import React, { Component} from 'react';
import { Button } from 'react-bootstrap';
import Auth from '../../Auth/Auth';
import moment from 'moment';

import './ReleaseHotfixNotes.scss';

const auth = new Auth();

export default class ReleaseHotfixNotes extends Component {
    constructor(props){
      super(props);

      this.state = {
          ReleaseHotfix: [],
          showAll : false
      };
    }

    async componentDidMount(){  
        let accessToken = await auth.getToken();
        fetch(`/api/ReleasesHotfixes`,{
            method : "GET",
            headers : {
                "Content-Type": "application/json",
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
            }
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(success => {
            if(success){
                this.setState({
                    ReleaseHotfix : success,
                    isLoading : false,
                    showAll : false
                });
            }            
        }).catch((error) => {
            console.error('Error:', error);
            window.apiError(error);
        });
    }

    getMoreReleaseNote(){
        this.setState({
            showAll : true
        });
    }

  render(){
    return (     
        <div id="ReleaseHotfixNotes" className="p-4 text-muted" >
             {this.state.ReleaseHotfix.map((items,index) =>
                <div className="release-note" key={index} style={this.state.showAll ? {display : "block"} : (!this.state.showAll && index !== 0) ? {display : "none"} : {display : "block"}}>
                    <div className="meta-data ">
                        <span className="type-update">{items.ReleaseType}</span>
                        <span className="release_date">{moment(items.ReleaseDate).format("MMM DD, YYYY")}</span>
                        by {items.ReleaseBy}
                    </div>
                    <div>
                        <h5 className="title mb-0" >
                            {items.ReleaseTitle}
                        </h5>
                        <small dangerouslySetInnerHTML={{ __html : items.ReleaseNotes}}></small>
                    </div>
                    <div className="mt-3">
                        <h3 className="note">Features</h3>
                        <ul>
                            {items.ReleaseFeatures.split("|").map(features => 
                                <li key={[features]}><p>{features}</p></li>
                            )}
                        </ul>
                        <h3 className="note">Updates</h3>
                        <ul>
                            {items.ReleaseUpdates.split("|").map(update => 
                                <li key={[update]}><p>{update}</p></li>
                            )}  
                        </ul>
                        <h3 className="note">Bug Fixes</h3>
                        <ul>
                            {items.ReleaseBugFixes.split("|").map(fix => 
                                <li key={[fix]}><p>{fix}</p></li>
                            )} 
                        </ul>
                    </div>
                </div>
             )} 
             {(!this.state.showAll && this.state.ReleaseHotfix.length > 1) &&  (
                <Button variant="link" className="w-100 text-center" onClick={() => this.getMoreReleaseNote()}><small>Show Archived Releases/Hotfixes</small></Button>  
             )} 
                            
        </div> 
    );
  }
}